import { useState, useContext } from 'react';
import { useIntl } from 'react-intl';
import dayjs from 'dayjs';
import { NotificationsContext } from '../../../../../../context/NotificationsContext';
import { downloadXlsx } from '../../../../../../services/api/workEmissions';

const useDownloadXlsxFile = (
  { id_project, work_code },
  concreteType = 'RC',
) => {
  const [loading, setLoading] = useState(false);
  const intl = useIntl();
  const { pushNotification } = useContext(NotificationsContext);

  const handleDownloadXlsx = async () => {
    setLoading(true);
    try {
      const response = await downloadXlsx(id_project, concreteType);

      if (!response || !response.data) {
        throw new Error(
          intl.formatMessage({ id: 'downloadXlsx.error.noData' }),
        );
      }
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `${work_code}_${
          concreteType === 'RC' ? 'M3HA' : 'M3HM'
        }_${dayjs().format('YYYYMMDD')}.xlsx`,
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Error al descargar el archivo Xlsx:', err);

      let errorMessage;

      if (!err.response && !err.request) {
        errorMessage = err.message;
      } else {
        errorMessage = intl.formatMessage({ id: 'downloadXlsx.error.generic' });
      }

      pushNotification({
        type: 'error',
        message: errorMessage,
      });
    } finally {
      setLoading(false);
    }
  };

  return { downloadXlsx: handleDownloadXlsx, loading };
};

export default useDownloadXlsxFile;
